import React from 'react';
import { useDrop } from 'react-dnd';
import classNames from 'classnames';

const TargetBox = (props) => {
    const [{isActive} , drop] = useDrop({
        accept: 'box',
        drop(item, monitor) {
            const didDrop = monitor.didDrop();
            if (didDrop) {
                return
            }
            props.onDropped(item);
        },
        collect: (monitor) => {
            return {
                isActive: monitor.canDrop() && monitor.isOver(),
            }
        },
    });
    return (
        <div className={'target-topic-box'}>
            <div className={classNames('block-item', isActive && 'block-item-active')}
                 style={{height: 'auto', minHeight: 350}} ref={drop}>
                <img src="/img/content/add_24px.svg" alt="" />
                <span>データプールからドラッグ&ドロップで追加</span>
            </div>
        </div>
    )
}
export default TargetBox
